import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialModal from "../MaterialModal";
import Button from "@material-ui/core/Button";
import withModal from "../withModal";
import { hideModal } from "../../../actions/actionCreators";
import { IAppState } from "../../../types/stores";

type Props = {
    isOpen: boolean;
};

const DataDiscoverySelectionsModal: React.FC<Props> = ({ isOpen }: Props) => {
    const dispatch = useDispatch();

    // State
    const [currentSelections, setCurrentSelections] = useState<Array<any>>([]);
    const [_, setResults] = useState<Array<any>>([]);

    // Props
    const selectedResults = useSelector((state: IAppState) => state.search.discoverySelectedResults);
    const discoveryAllResults = useSelector((state: IAppState) => state.search.discoveryAllResults);

    const audienceDiscoveryName = "Audience Insights";
    const title = `Data ${audienceDiscoveryName} Selections`;

    useEffect(() => {
        setResults(currentSelections ? currentSelections.map(x => discoveryAllResults[x]) : []);
    }, [currentSelections, discoveryAllResults]);

    const hide = () => dispatch(hideModal("DISCOVERY_SELECTIONS"));

    const recordCurrentDataDiscoverySelections = () => setCurrentSelections([...selectedResults]);

    const footer = (
        <div>
            <Button onClick={hide} color="primary" className="material-modal-cancel-btn">
                Cancel
            </Button>
        </div>
    );

    return (
        <MaterialModal
            id="data-discovery-modal"
            isOpen={isOpen}
            title={title}
            primaryButtonText="Submit"
            onClose={hide}
            footer={footer}
            afterOpen={recordCurrentDataDiscoverySelections}
        ></MaterialModal>
    );
};

export default withModal(DataDiscoverySelectionsModal, "DISCOVERY_SELECTIONS");
